module.exports = __webpack_public_path__ + "static/media/vk-social-network-logo.e0e45ad0.svg";